import React, { useMemo } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import HeaderDescription from "../../../../components/commons/HeaderDescription";
import ImageView from "../../../../components/commons/ImageView";

// Helper to safely parse JSON
// const safeJsonParse = (data) => {
//   try {
//     return JSON.parse(data);
//   } catch {
//     return {};
//   }
// };

const safeJsonParse = (data) => {
  try {
    if (typeof data === "object" && data !== null) {
      // Already parsed
      return data;
    }

    if (typeof data === "string") {
      let parsed = data;

      // Keep parsing while it's a valid JSON string
      while (typeof parsed === "string") {
        try {
          parsed = JSON.parse(parsed);
        } catch {
          break;
        }
      }

      return parsed && typeof parsed === "object" ? parsed : {};
    }

    return {};
  } catch {
    return {};
  }
};

const DeletedDocumentsInfo = ({ onboardingData }) => {
  const networkDocs = onboardingData?.network?.networkDocs || [];
  const onboardingDocs = onboardingData?.onboardingDocs || [];

  const mergedDocs = useMemo(() => {
    const order = ["Text", "Pattern", "Image", "File"];

    return networkDocs
      .map((doc) => {
        const existing = onboardingDocs.find((d) => d.networkDocId === doc.id);
        // const parsedData = safeJsonParse(existing?.data || "{}");
        const parsedData = existing?.data;

        return { ...doc, existingData: parsedData };
      })
      .sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type))
      .filter((doc) => !!doc?.isDeleted);
  }, [networkDocs, onboardingDocs]);

  const initialValues = useMemo(() => {
    return mergedDocs.reduce((acc, doc) => {
      if (doc.type === "Image" || doc.type === "File") {
        // acc[doc.name] =
        //   safeJsonParse(doc.existingData || "{}")?.image ||
        //   safeJsonParse(doc.existingData || "{}")?.front ||
        //   "";
        acc[doc.name] = doc.existingData;
      } else if (doc.type === "Text" || doc.type === "Pattern") {
        acc[doc.name] = safeJsonParse(doc.existingData || "{}")?.value || "";
        // acc[doc.name] = doc.existingData;
      } else {
        acc[doc.name] = doc.existingData;
      }

      return acc;
    }, {});
  }, [mergedDocs]);

  return (
    <div className="width-full">
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values) => {
          console.log("Form submitted:", values);
        }}
      >
        {({ setFieldValue }) => (
          <Form className="px-28 pb-40">
            <HeaderDescription
              heading="Deleted Documents"
              description="In here all the deleted documents detail. The documents that are deleted by admin from network."
            />

            <div className="mt-20">
              {/* field printing */}
              <div className="grid-two">
                {mergedDocs.map((doc, index) => {
                  const { id, name, type, mandatory, existingData } = doc;
                  const fieldName = name;
                  const existingDataConvert = safeJsonParse(existingData);

                  // Render field based on type
                  const renderField = () => {
                    // TEXT / PATTERN
                    if (type === "Text" || type === "Pattern") {
                      return (
                        <div className="">
                          <div className="input-field-md-lg" key={id}>
                            <label>
                              {name}{" "}
                              {mandatory && (
                                <span className="onboarding-custom-required">
                                  *
                                </span>
                              )}
                            </label>
                            <Field
                              name={fieldName}
                              type="text"
                              placeholder={`Enter ${name}`}
                              // className="onboarding-custom-input"
                              className="type-input-focus"
                              disabled={true}
                            />
                            <ErrorMessage
                              name={fieldName}
                              component="p"
                              className="onboarding-custom-error"
                            />
                          </div>
                        </div>
                      );
                    }

                    // return null;
                  };

                  return <div>{renderField()}</div>;
                })}
              </div>
              {/* image and file printing */}
              {/* <div className="onboarding-custom-row"> */}
              <div className="grid-two">
                {mergedDocs.map((doc, index) => {
                  const { id, name, type, mandatory, existingData } = doc;
                  const fieldName = name;
                  const existingDataConvert = safeJsonParse(existingData);

                  // Render image and file
                  const renderImageField = () => {
                    // IMAGE
                    if (type === "Image" && !existingDataConvert?.file) {
                      return (
                        <div>
                          <div className="onboarding-custom-field" key={id}>
                            <label className="onboarding-custom-label">
                              {name}{" "}
                              {mandatory && (
                                <span className="onboarding-custom-required">
                                  *
                                </span>
                              )}
                            </label>

                            {existingDataConvert ? (
                              <div>
                                <div className="onboarding-custom-image-wrapper">
                                  {Object.entries(existingDataConvert)
                                    .filter(([key]) =>
                                      [
                                        "front",
                                        "back",
                                        "side",
                                        "image",
                                      ].includes(key)
                                    )
                                    .map(([key, url]) => (
                                      <div
                                        key={key}
                                        className="onboarding-custom-image-box"
                                      >
                                        <ImageView src={url} />
                                        {/* <img
                                    src={url}
                                    alt={`${name} ${key}`}
                                    className="onboarding-custom-image"
                                  /> */}
                                        <p className="onboarding-custom-image-text">
                                          {key}
                                        </p>
                                      </div>
                                    ))}
                                </div>
                                {existingDataConvert?.expiry && (
                                  <>
                                    <p
                                      className="name-badge mt-12"
                                      style={{
                                        width: "max-content",
                                      }}
                                    >
                                      Expiry:{" "}
                                      {new Date(
                                        existingDataConvert?.expiry
                                      ).toLocaleDateString("en-CA")}
                                    </p>
                                  </>
                                )}
                              </div>
                            ) : (
                              <input
                                type="file"
                                accept="image/*"
                                disabled={true}
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (file) setFieldValue(fieldName, file);
                                }}
                                className="onboarding-custom-input-file"
                              />
                            )}
                          </div>
                        </div>
                      );
                    }

                    // FILE

                    if (
                      (type === "Image" || type === "File") &&
                      existingDataConvert?.file
                    ) {
                      const hasExistingFile = existingDataConvert?.file;

                      return (
                        <div>
                          <div className="onboarding-custom-field" key={id}>
                            <label className="onboarding-custom-label">
                              {name}{" "}
                              {mandatory && (
                                <span className="onboarding-custom-required">
                                  *
                                </span>
                              )}
                            </label>

                            {hasExistingFile ? (
                              <div>
                                <a
                                  href={existingDataConvert.file}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    margin: "5px",
                                    display: "inline-block",
                                    padding: "5px 10px",
                                    color: "#000",
                                    backgroundColor: "#ADD8E6",
                                    borderRadius: "4px",
                                    textDecoration: "none",
                                    fontWeight: 500,
                                  }}
                                >
                                  View
                                </a>

                                {/* Optional: allow replacing file */}
                                {/* <input
                              type="file"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) setFieldValue(fieldName, file);
                              }}
                              className="onboarding-custom-input-file"
                              style={{ marginLeft: "10px" }}
                            /> */}
                              </div>
                            ) : (
                              <input
                                type="file"
                                disabled={true}
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (file) setFieldValue(fieldName, file);
                                }}
                                className="onboarding-custom-input-file"
                              />
                            )}

                            <ErrorMessage
                              name={fieldName}
                              component="p"
                              className="onboarding-custom-error"
                            />
                          </div>
                        </div>
                      );
                    }

                    // return null;
                  };

                  return (
                    <div
                      key={id}
                      // className={`onboarding-custom-column ${
                      //   (index + 1) % 2 === 0 ? "right" : "left"
                      // }`}
                    >
                      {renderImageField()}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* <button type="submit" className="onboarding-custom-btn">
              Save Documents
            </button> */}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default DeletedDocumentsInfo;
